<template>
  <nd-dialog
    v-model="visible"
    close-btn
    :footer="false"
    title="购买须知"
  >
    <div class="pay-content">
      <div class="pay-info">
        您已选择购买{{loanProcessTitle}}，可畅享<span v-if="userInfo.sj !== 'Y'">专属资金及</span>海量生活权益优惠。
        如您借款成功，您需分期支付权益购买费用；
        如您借款失败，将不产生任何权益费用。
      </div>
      <nd-button
        class="pay-btn"
        @click="next"
      >确认购买</nd-button>
    </div>
  </nd-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'vvipTipsDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    repayBillNo: {
      type: String,
      default: ''
    },
    loanProcessTitle: {
      type: String,
      default: '大权益'
    }
  },
  data () {
    return {
    }
  },
  computed: {
    
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    ...mapState('user', ['userInfo'])
  },
  methods: {
    // 跳转去支付
    next () {
      this.visible = false
      this.$emit('on-next')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.pay-content{
  padding: 30px 50px;
  text-align: left;
  .pay-info{
    font-size: 28px;
  }
  .pay-btn{
    width: 100%;
    margin-top: 100px;
  }
}
</style>